var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._l((_vm.lines),function(line,i){return [(i > 0)?_c('br',{key:("br-" + i)}):_vm._e(),_c('span',{key:("line-" + i)},[_vm._v(_vm._s(line))])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }